import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Navigate } from 'react-router';
import { makeLinks, withRouter } from 'utils/common';
import axios from 'axios';
import moment from 'moment';
import { TRAVEL_FILTERS, PAYMENT, PAYMENT_RESPONSE } from 'utils/constants';
import { parseQueryString } from 'utils/common';
import i18n from 'utils/translate';
import endpoints from 'utils/endpoints';
import Confirmation from './Pages/Confirmation';
import PersonalData from './Pages/PersonalData';
import Head from 'components/Head';
import PaymentSuccess from 'components/PaymentSuccess';
import PaymentError from 'components/PaymentError';
import { insertAfter } from 'utils/common';
import { animateScroll } from 'react-scroll';
import Payment from './Pages/Payment';
import { DATA_STORAGE_KEY, PAYMENT_STORAGE_KEY } from './constants';
import { GENDER_MALE } from 'utils/constants';
import TravelDetails from './Pages/TravelDetails';
import { partial } from 'underscore';
import { toast } from 'react-toastify';
import ErrorMessage from 'components/ErrorMessage';
import SummaryBox from 'components/SummaryBox';

const steps = [
  { text: i18n('Versicherung'), url: '', icon: 'insurance' },
  { text: i18n('Personendaten'), url: 'personal', icon: 'identification' },
  { text: i18n('Zahlung'), url: 'payment', icon: 'wallet' },
  { text: i18n('Abschluss'), url: 'confirmation', icon: 'badge' }
];

class TravelInsuranceContainer extends Component {
  constructor(props) {
    super(props);

    const { location } = props;

    this.params = {};
    this.ajaxLoading = false;
    this.blockPayment = false;

    this.state = {
      loading: false,
      apiErrorMessages: [],
      restored: false
    };

    if (location.pathname.indexOf('/confirm') === -1) {
      sessionStorage.clear();
    }

    this.initializeData();

    this.urls = {
      travel: '/',
      personal: '/personal',
      payment: '/payment',
      confirm: '/confirmation',
      success: '/success',
      error: '/error'
    };
  }

  initializeData = () => {
    this.data = {
      vacation: {
        type: TRAVEL_FILTERS.SINGLE,
        destination: TRAVEL_FILTERS.INLAND
      },
      personal: {
        anrede: GENDER_MALE,
        land: 'AT'
      },
      payment: {
        type: PAYMENT.HOBEX
      },
      documents: {},
      promotion: false,
      visaRequired: false,
      acceptTerms: false,
      acceptEmailSend: null,
      coinsured: [
        {
          anrede: GENDER_MALE,
          geburtsdatum: null
        }
      ]
    };
  };

  componentDidMount() {
    // Restore data (if any) from temporary storage
    const frozen = sessionStorage.getItem(DATA_STORAGE_KEY);
    if (frozen === null) {
      this.setState({
        restored: true
      });
      return;
    }
    try {
      const data = JSON.parse(frozen);
      this.data = data;

      this.setState({ ...data, restored: true });
    } catch (e) {
      console.log({ e });
      // Nothing to do here: this was an optional op
    }
  }

  makeQuoteModel({ startDate, endDate, type, cancellation, bookingDate }) {
    const { brokerNumber } = this.data;
    const { anrede, vorname, nachname, geburtsdatum, strasse, nr, plz, ort, email, telefon } = this.data.personal;
    const { graweInfos } = this.data.payment;

    return {
      reisebeginn: startDate ? startDate.format('DD.MM.YYYY') : null,
      reiseende: endDate ? endDate.format('DD.MM.YYYY') : null,
      versicherungstyp: type,
      stornoschutz: cancellation,
      buchungsdatum: bookingDate ? bookingDate.format('DD.MM.YYYY') : null,
      graweInfos,
      vermittlerNr: brokerNumber,
      versicherter: {
        anrede,
        vorname,
        nachname,
        geburtsdatum: geburtsdatum ? moment(geburtsdatum).format('DD.MM.YYYY') : '01.01.2000',
        strasse,
        nr,
        plz,
        ort,
        email,
        telefon,
        land: 'AT'
      }
    };
  }

  calculateQuote = vacationDetails => {
    console.log('VACATION DETAILS ', vacationDetails);
    const data = this.makeQuoteModel(vacationDetails || this.data.vacation);
    console.log('DATA VACAY ', data);

    if (this.data.vacation.type === TRAVEL_FILTERS.FAMILY) {
      data.versicherter = {
        anrede: 1,
        vorname: 'John',
        nachname: 'Doo',
        geburtsdatum: '27.07.1999',
        strasse: 'Milkey Way',
        nr: '20',
        plz: '4020',
        ort: 'Andromeda',
        land: 'AT',
        email: 'bla@bla.com',
        telefon: '0'
      };
      // needed by the API to calculate the correct family quote
      data.mitversicherte = [
        {
          anrede: 1,
          vorname: 'Peter',
          nachname: 'Doo',
          geburtsdatum: '27.07.2015'
        }
      ];
    }

    return axios({
      baseURL: GRAWE.api_root,
      url: endpoints.travel.GET_PRICE,
      method: 'post',
      data,
      withCredentials: true
    })
      .then(response => response.data)
      .then(({ ok, praemie: price, waehrung: currency, validierungsMeldungen }) => {
        if (!ok) {
          validierungsMeldungen.forEach(error => {
            toast.error(<ErrorMessage header={error.feld} message={error.validierungsText} />);
          });
          return { validierungsMeldungen };
        } else {
          toast.dismiss();
          return { price, currency, validierungsMeldungen };
        }
      })
      .catch(() => null)
      .then(quote => (this.data.quote = quote));
  };

  restoreData = () => {
    const frozen = sessionStorage.getItem(DATA_STORAGE_KEY);

    if (frozen === null) {
      this.setState({
        restored: true
      });
    }

    try {
      const data = JSON.parse(frozen);
      const startDate = moment(data.data.vacation.startDate);
      const endDate = moment(data.data.vacation.endDate);
      const bookingDate = moment(data.data.vacation.bookingDate);
      const birthdate = moment(data.data.personalData.birthdate);

      if (data.data.coinsured && data.data.coinsured.length) {
        data.data.coinsured.map(person => {
          return { ...person, birthdate: moment(person.birthdate) };
        });
      }

      this.setState({
        ...data,
        vacation: {
          ...data.data.vacation,
          startDate,
          endDate,
          bookingDate
        },
        personalData: {
          ...data.data.personalData,
          birthdate
        },
        restored: true
      });
    } catch (e) {
      // Nothing to do here: this was an optional op
    }
  };

  updateData = (key, value) => {
    this.data[key] = value;
    this.setState({ [key]: value });
  };

  storeTemporarily() {
    // store data to be temporarily picked up by re-navigation
    const frozen = JSON.stringify(this.state);
    sessionStorage.setItem(DATA_STORAGE_KEY, frozen);
  }

  resetApiErrors = () => {
    this.setState({
      apiErrorMessages: []
    });
  };

  handleSubmit = requestInfo => {
    this.setState({
      loading: true
    });

    axios({
      method: 'post',
      url: GRAWE.api_root + requestInfo.endpoint,
      data: requestInfo.request,
      withCredentials: true
    }).then(
      ({ data }) => {
        if (requestInfo.request.bezahlung.type === PAYMENT.HOBEX) {
          this.handleHobexResponse(data);
        } else {
          this.handleSepaResponse(data);
        }
      },
      () => {
        const apiErrorMessages =
          requestInfo.request.bezahlung.type === PAYMENT.HOBEX
            ? [{ validierungsText: `${i18n('Kreditkartenzahlung fehlgeschlagen')}` }]
            : [{ validierungsText: `${i18n('SEPA-Zahlung fehlgeschlagen')}` }];

        toast.error(<ErrorMessage message={apiErrorMessages[0].validierungsText} />);

        this.setState({
          loading: false,
          apiErrorMessages
        });
      }
    );
  };

  handleHobexResponse = data => {
    if (data.ok) {
      this.setState(
        {
          documents: {
            bestellID: data.bestellID
          },
          hobexData: {
            hobexUrl: data.hobexUrl,
            actionUrl: data.actionUrl
          }
        },
        () => {
          this.storeTemporarily();
          const confirmationPage = document.getElementById('confirmation-wrapper');

          let widgetWrapper = document.createElement('div');
          widgetWrapper.setAttribute('id', 'widgetWrapper');

          let hobexWidgetOptions = document.createElement('script');
          hobexWidgetOptions.text = 'var wpwlOptions = {locale: "de"}';

          let hobexWidget = document.createElement('script');
          hobexWidget.src = data.hobexUrl;

          let hobexForm = document.createElement('form');
          hobexForm.classList.add('paymentWidgets');
          hobexForm.setAttribute('data-brands', 'MASTER VISA');
          hobexForm.action = window.location.href + '?callback=' + data.actionUrl;

          confirmationPage.classList.add('hidden');
          animateScroll.scrollToTop({ duration: 0 });
          widgetWrapper.appendChild(hobexWidgetOptions);
          widgetWrapper.appendChild(hobexWidget);
          widgetWrapper.appendChild(hobexForm);
          insertAfter(widgetWrapper, confirmationPage);
          window.onpopstate = function () {
            document.getElementById('widgetWrapper').remove();
          };
        }
      );
      this.setState({ loading: false });
    } else {
      const apiErrorMessages = data.validierungsMeldungen.length
        ? data.validierungsMeldungen
        : [{ validierungsText: `${i18n('Kreditkartenzahlung fehlgeschlagen')}` }];

      toast.error(<ErrorMessage message={apiErrorMessages[0].validierungsText} />);

      this.setState({ apiErrorMessages, loading: false });
    }
  };

  handleSepaResponse = data => {
    const { navigate } = this.props.router;

    if (
      (data.ok && data.status === PAYMENT_RESPONSE.SUCCESS) ||
      (data.ok && data.status === PAYMENT_RESPONSE.REVEIW) ||
      (data.ok && data.status === PAYMENT_RESPONSE.INITIATED)
    ) {
      this.setState({
        apiErrorMessages: [],
        documents: {
          bestellID: data.bestellID,
          folderUrl: data.folder ? data.folder.downloadUrl : '',
          policyUrl: data.policy ? data.policy.downloadUrl : '',
          kubaUrl: data.kuba ? data.kuba.downloadUrl : '',
          visaUrl: data.visa ? data.visa.downloadUrl : ''
        },
        status: data.status,
        loading: false
      });
      navigate('/success');
    } else {
      const errors = data.validierungsMeldungen.length
        ? data.validierungsMeldungen
        : [{ validierungsText: `${i18n('SEPA-Zahlung fehlgeschlagen')}` }];

      this.setState({
        apiErrorMessages: errors,
        loading: false
      });
    }
  };

  makeLinks(previous, current, next) {
    const { navigate, location } = this.props.router;

    return makeLinks(previous, current, next, navigate, location);
  }

  handleCreditCardPayment = params => {
    const url = GRAWE.api_root + decodeURIComponent(params.callback);

    return axios({
      url,
      withCredentials: true
    });
  };

  creditCardStorno = () => {
    const { navigate } = this.props.router;

    this.handleCreditCardPayment(this.params, true).then(
      () => {
        sessionStorage.clear();
        navigate('/error');
      },
      () => {
        sessionStorage.clear();
        navigate('/error');
      }
    );
  };

  renderVacationDetailsPage = () => {
    sessionStorage.clear();

    const props = {
      calculateQuote: this.calculateQuote,
      ...this.makeLinks(null, this.urls.travel, this.urls.personal),
      onChange: partial(this.updateData, 'vacation'),
      listItems: window.benefits,
      vacation: this.data.vacation
    };

    return <TravelDetails {...props} />;
  };

  renderSummaryBox() {
    const { quote, vacation } = this.data;

    const sections = {
      ...vacation,
      startDate: vacation.startDate.format('DD.MM.YYYY'),
      endDate: vacation.endDate.format('DD.MM.YYYY')
    };

    const finalPrice = quote?.price ?? 0;
    const currency = quote?.currency ?? '';

    const props = {
      title: i18n('Zusammenfassung'),
      finalPrice,
      currency,
      bookingDate: vacation.bookingDate,
      quoteType: 'once',
      sections
    };

    return <SummaryBox {...props} />;
  }

  renderPersonalData = () => {
    if (
      this.data.vacation.type === null ||
      this.data.vacation.destination === null ||
      !this.data.vacation.startDate ||
      !this.data.vacation.endDate
    ) {
      return <Navigate replace to={this.urls.travel} />;
    }

    const { quote } = this.data;

    sessionStorage.clear();

    const props = {
      quote,
      ...this.makeLinks(this.urls.travel, this.urls.personal, this.urls.payment),
      onChange: ({ key, data }) => this.updateData(key, data),
      data: this.data,
      renderSummaryBox: this.renderSummaryBox()
    };

    return <PersonalData {...props} />;
  };

  renderPaymentPage = () => {
    const { personal, quote } = this.data;

    if (!personal.vorname || !personal.nachname || !personal.geburtsdatum) {
      return <Navigate replace to={this.urls.personal} />;
    }

    const props = {
      quote,
      ...this.makeLinks(this.urls.personal, this.urls.payment, this.urls.confirm),
      data: this.data,
      onChange: ({ key, data }) => this.updateData(key, data),
      renderSummaryBox: this.renderSummaryBox()
    };

    return <Payment {...props} />;
  };

  renderConfirmation = () => {
    const { quote } = this.data;

    if (!quote) {
      return <Navigate replace to={this.urls.travel} />;
    }

    const {
      vacation,
      personal,
      coinsured,
      payment,
      promotion,
      visaRequired,
      acceptEmailSend,
      brokerNumber,
      quote: { price, currency }
    } = this.data;

    const { loading } = this.state;

    if (acceptEmailSend === null) {
      return <Navigate replace to={this.urls.payment} />;
    }

    const { navigate } = this.props.router;
    let apiErrorMessages = this.state.apiErrorMessages;

    if (this.blockPayment) {
      this.blockPayment = false;
      navigate('/');
    }

    if (window.location.hash.indexOf('callback') > 0) {
      this.params = parseQueryString(window.location.hash.substring(window.location.hash.indexOf('?') + 1));
      this.paramsFirst = window.location.hash.substring(15, 23);
      if (
        !sessionStorage.getItem(DATA_STORAGE_KEY) ||
        (!this.ajaxLoading && JSON.parse(sessionStorage.getItem(PAYMENT_STORAGE_KEY)))
      ) {
        sessionStorage.clear();
        this.initializeData();
        return <Navigate replace to={this.urls.travel} />;
      }

      if (this.paramsFirst === 'callback' && !this.ajaxLoading) {
        this.ajaxLoading = true;
        sessionStorage.setItem(PAYMENT_STORAGE_KEY, true);
        this.handleCreditCardPayment(this.params).then(
          ({ data }) => {
            if (
              (data.ok && data.status === PAYMENT_RESPONSE.SUCCESS) ||
              (data.ok && data.status === PAYMENT_RESPONSE.REVEIW) ||
              (data.ok && data.status === PAYMENT_RESPONSE.INITIATED)
            ) {
              let widget = document.getElementById('widgetWrapper');
              if (widget) {
                widget.remove();
              }

              this.setState({
                apiErrorMessages: [],
                documents: {
                  bestellID: data.bestellID,
                  folderUrl: data.folder ? data.folder.downloadUrl : '',
                  policyUrl: data.policy ? data.policy.downloadUrl : '',
                  kubaUrl: data.kuba ? data.kuba.downloadUrl : '',
                  visaUrl: data.visa ? data.visa.downloadUrl : ''
                },
                status: data.status
              });
              navigate(this.urls.success);
            } else {
              sessionStorage.clear();
              navigate('/error');
              apiErrorMessages = [{ validierungsText: `${i18n('Kreditkartenzahlung abgelehnt')}` }];
              toast.error(<ErrorMessage message={apiErrorMessages[0].validierungsText} />);
            }
            this.ajaxLoading = false;
          },
          () => {
            this.ajaxLoading = false;
            this.creditCardStorno();
            apiErrorMessages = [{ validierungsText: `${i18n('Kreditkartenzahlung abgelehnt')}` }];
            toast.error(<ErrorMessage message={apiErrorMessages[0].validierungsText} />);
          }
        );
      }
    }

    const props = {
      info: {
        vacation,
        personal,
        payment,
        coinsured,
        promotion,
        visaRequired,
        acceptEmailSend,
        price,
        currency,
        brokerNumber
      },
      loading,
      paymentPending: this.ajaxLoading,
      onRender: this.resetApiErros,
      onConfirm: this.handleSubmit,
      apiErrorMessages,
      ...this.makeLinks(this.urls.payment, this.urls.confirm, null)
    };

    return <Confirmation {...props} />;
  };

  renderSuccessPage = () => {
    const { documents, status } = this.state;
    const { personal, cubaTrip, visaRequired } = this.data;

    if (!personal.vorname || !personal.nachname || !personal.geburtsdatum) {
      return <Navigate replace to={this.urls.travel} />;
    }

    return (
      <PaymentSuccess
        vacation
        documents={documents}
        cubaTrip={cubaTrip}
        visaRequired={visaRequired}
        status={status}
        onSuccess={() => {
          this.blockPayment = true;
        }}
        resetData={this.initializeData}
      />
    );
  };

  render() {
    const { restored } = this.state;

    const prefix = window.base === '/' ? '' : window.base;

    if (!restored) {
      return null;
    }

    if (this.state.hasError) {
      return <div className="text-center">Something went wrong</div>;
    }

    return (
      <div>
        <Head
          smallTitle={i18n('grawe travelstar')}
          title={i18n('Reiseversicherung')}
          steps={steps.map(route => ({ ...route }))}
          showSteps={window.location.pathname !== `${prefix}/success` && window.location.pathname !== `${prefix}/error`}
        />
        <Routes>
          <Route path={this.urls.travel} Component={this.renderVacationDetailsPage} />
          <Route path={this.urls.personal} Component={this.renderPersonalData} />
          <Route path={this.urls.payment} Component={this.renderPaymentPage} />
          <Route path={this.urls.confirm} Component={this.renderConfirmation} />
          <Route path={this.urls.success} Component={this.renderSuccessPage} />
          <Route path={this.urls.error} element={<PaymentError />} />
          <Route path="/" element={<Navigate replace to={this.urls.travel} />} />
        </Routes>
      </div>
    );
  }

  componentDidCatch(error, errorInfo) {
    console.log(error.message);
    console.log(errorInfo.componentStack);
    this.setState({ hasError: true });
  }
}

export default withRouter(TravelInsuranceContainer);
